import * as React from 'react';
import { StoreState } from '@ui/store/rootReducer';
import { connect } from 'react-redux';
import { LoadableContent, Page, PageNavigation } from '@ui/components';
import { storesSelectors } from '..';
import StoresPanel from '../components/StoresPanel';
import Store from '../components/Store';
import * as actions from '../services/actions';
import StoresLeftSide from './StoresLeftSide';

import './Stores.less';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Divider, Icon } from 'antd';

interface StateToProps {
  stores?: any[];
  loading: boolean;
  openCity: any;
}

interface DispatchToProps {
  removeStore: (storeId: string) => void;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class Stores extends React.PureComponent<Props> {
  handleOpenCreateStore = () => {
    const { history } = this.props;
    history.push('/create-store');
  };

  handleOpenEditStore = (storeId: any) => {
    const { history } = this.props;
    history.push(`/edit-store/${storeId}`);
  };

  render(): React.ReactNode {
    const { loading, openCity, stores = [], removeStore } = this.props;

    const StoresMarkets = stores.reduce((result, store) => {
      if (store.market) {
        const market = store.market;
        const key = `market__${market.id}`;
        const resultMarket = result[key];
        if (resultMarket) {
          return {
            ...result,
            [key]: {
              ...resultMarket,
              stores: [...resultMarket.stores, store],
            },
          };
        }
        return { ...result, [key]: { ...market, stores: [store] } };
      }

      return { ...result, [store.id]: { ...store } };
    }, {});

    return (
      <LoadableContent loading={loading}>
        <div className="stores-page">
          <PageNavigation title="Магазины">
            <Button
              type="primary"
              size="large"
              className="stores-panel__create-store__button"
              onClick={this.handleOpenCreateStore}
            >
              <Icon type="plus" />
              Добавить магазин
            </Button>
          </PageNavigation>
          <Page>
            <Page.LeftSide>
              <StoresLeftSide />
            </Page.LeftSide>
            <Page.Content>
              <div className="stores">
                {openCity && (
                  <StoresPanel region={openCity.region} city={openCity.city} />
                )}
                {Object.values(StoresMarkets).map((market: any) => {
                  return !market.stores ? (
                    <Store
                      key={market.id}
                      store={market}
                      removeStore={removeStore}
                      editStore={this.handleOpenEditStore}
                    />
                  ) : (
                    <div>
                      <Divider orientation="left" className="stores-divider">
                        ТЦ "{market.name}"
                      </Divider>
                      {market.stores.map((store: any) => (
                        <Store
                          key={store.id}
                          store={store}
                          removeStore={removeStore}
                          editStore={this.handleOpenEditStore}
                        />
                      ))}
                    </div>
                  );
                })}
              </div>
            </Page.Content>
          </Page>
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  stores: storesSelectors.getStores(state),
  loading: storesSelectors.getStoresLoading(state),
  openCity: storesSelectors.getOpenCity(state),
});

const mapDispatchToProps = {
  removeStore: actions.removeStoreRequested,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Stores),
);



// WEBPACK FOOTER //
// ./src/scenes/Stores/containers/Stores.tsx